"use strict";

import { APP_API_URL } from "@/consts";
import { useAuthStore } from "@/stores/auth.module";
import axios from "axios";

const apiclient = axios.create({
  baseURL: APP_API_URL,
});

apiclient.interceptors.request.use((config) => {
  const authStore = useAuthStore();

  const params = new URLSearchParams(config.params || {});

  // We should add institution_id if there is not any
  if (!params.has("institution_id")) {
    params.set("institution_id", authStore.institutionId);
  }

  config.params = params;

  return config;
});

let cancelToken: any;
apiclient.cancelAndGetToken = function getToken() {
  if (cancelToken) {
    cancelToken.cancel("Request cancelled");
  }
  cancelToken = axios.CancelToken.source();
  return cancelToken;
};

export default apiclient;
